const LAYOUT_EN_LOWER = "`qwertyuiop[]asdfghjkl;'zxcvbnm,./"
const LAYOUT_RU_LOWER = "ёйцукенгшщзхъфывапролджэячсмитьбю."
const LAYOUT_EN_UPPER = "~QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>?"
const LAYOUT_RU_UPPER = "ЁЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,"

const mapChar = (char, from, to) => {
  const index = from.indexOf(char)
  return index >= 0 ? to[index] : char
}

const switchCharLayout = (char, fromLower, toLower, fromUpper, toUpper) => {
  const lower = mapChar(char, fromLower, toLower)
  if (lower !== char) return lower

  return mapChar(char, fromUpper, toUpper)
}

export const switchKeyboardLayoutEnToRu = (text = "") =>
  text
    .split("")
    .map((char) => switchCharLayout(char, LAYOUT_EN_LOWER, LAYOUT_RU_LOWER, LAYOUT_EN_UPPER, LAYOUT_RU_UPPER))
    .join("")

export const switchKeyboardLayoutRuToEn = (text = "") =>
  text
    .split("")
    .map((char) => switchCharLayout(char, LAYOUT_RU_LOWER, LAYOUT_EN_LOWER, LAYOUT_RU_UPPER, LAYOUT_EN_UPPER))
    .join("")

export const getKeyboardLayoutQueryVariants = (query = "") => {
  const normalized = query.toLowerCase()
  const variants = [
    normalized,
    switchKeyboardLayoutEnToRu(normalized).toLowerCase(),
    switchKeyboardLayoutRuToEn(normalized).toLowerCase(),
  ]

  return variants.filter((variant, index) => variant && variants.indexOf(variant) === index)
}

export const textMatchesQueryVariants = (text = "", queryVariants = []) => {
  const normalized = (text || "").toLowerCase()
  return queryVariants.some((query) => normalized.includes(query))
}
